import { Checkbox, Select } from 'antd'

const { Option } = Select

export type MultiOpcao = { value: string; label: string; title?: string }

type Props = {
  value: string[]
  onChange: (v: string[]) => void
  options: MultiOpcao[]
}

/** Select múltiplo com checkbox nas opções (mesmo padrão do filtro "Empresa Selecionada"). */
const MultiFiltro: React.FC<Props> = ({ value, onChange, options }) => (
  <Select
    mode="multiple"
    allowClear
    value={value}
    onChange={onChange}
    placeholder="Todos"
    maxTagCount="responsive"
    optionLabelProp="label"
    optionFilterProp="label"
    menuItemSelectedIcon={null}
    showArrow
    dropdownMatchSelectWidth={false}
    style={{ width: '100%' }}
  >
    {options.map((o) => (
      <Option key={o.value} value={o.value} label={o.label} title={o.title || o.label}>
        <span title={o.title || o.label}>
          <Checkbox checked={value.includes(o.value)} style={{ marginRight: 8 }} />
          {o.label}
        </span>
      </Option>
    ))}
  </Select>
)

export default MultiFiltro
